import { sentPasswordResetLink } from "api/userManagement";
import { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { UserIcon } from "themes/Icon";
import AvatarComp from "themes/elements/Avatar";
import ModalComp from "themes/elements/Modal";
import TagComp from "themes/elements/Tag";
import { retrieveUserData } from "utils/cryptoStorage";
import { isPermit } from "utils/permissionCheck";
import ModalFooter from "../modalFooter";
import style from "./user_details.module.scss";

function UserDetails({ open, setOpen, setEdit }) {
  const userToken = retrieveUserData();
  let admin_user_id, admin_user_name;
  const [loading, setLoading] = useState(false);

  if (userToken) {
    ({ admin_user_id, admin_user_name } = userToken);
  }
  const { selectedUser } = useSelector((state) => state.users);

  const handleSendPasswordResetLink = async () => {
    setLoading(true);
    try {
      const response = await sentPasswordResetLink({
        email: selectedUser?.email,
        action: "reset-password'",
      });
      setLoading(false);

      toast.success(response?.message);
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalComp
      title="User details"
      footer={
        <ModalFooter
          handleSecondaryBtn={() => {
            setOpen(false);
            setEdit(true);
          }}
          handlePrimaryBtn={() => {
            handleSendPasswordResetLink();
          }}
          primaryBtnloading={loading}
          secondaryBtnText="Edit user"
          primaryBtnVariant="secondary"
          hidePrimaryBtn={!isPermit(2, "edit") || selectedUser?.user_type === 2}
          primaryBtnText="Send password reset link"
          hideSecondaryBtn={!isPermit(2, "edit")}
        />
      }
      open={open}
      setOpen={setOpen}
    >
      <div className={`flex gap-6 ${style["content-wrapper"]}`}>
        <div className={style["profile-pic"]}>
          {selectedUser?.user_image?.length > 0 ? (
            <AvatarComp size={100} blue src={selectedUser?.user_image} />
          ) : (
            <AvatarComp blue size={100} userDetails>
              {selectedUser?.name?.slice(0, 1).toUpperCase()}
            </AvatarComp>
          )}
        </div>
        <div className="flex flex-column gap-4 w-full">
          {/* Name */}
          <div className="flex flex-column gap-1">
            <label htmlFor="" className="text-normal text-gray">
              Name
            </label>
            <h6 className={style["details-value"]}>{selectedUser?.name}</h6>
          </div>
          {/* Email */}
          <div className="flex flex-column gap-1">
            <label htmlFor="" className="text-normal text-gray">
              Email
            </label>
            <h6 className={style["details-value"]}>{selectedUser?.email}</h6>
          </div>
          {/* Created date */}
          <div className="flex flex-column gap-1">
            <label htmlFor="" className="text-normal text-gray">
              Created on
            </label>
            <h6 className={style["details-value"]}>
              {selectedUser?.created_date}
            </h6>
          </div>
          <div className="flex flex-column gap-1">
            <label htmlFor="" className="text-normal text-gray">
              User type
            </label>
            <TagComp color="#FFF0E3">
              {" "}
              {selectedUser?.user_type === 1
                ? "CSD User"
                : "Active directory user"}
            </TagComp>
          </div>
          <div className="flex flex-column gap-1">
            <label htmlFor="" className="text-normal text-gray">
              Status
            </label>
            <TagComp
              className={
                selectedUser?.user_status_flg === 1
                  ? "ant-tag-green"
                  : "ant-tag-red"
              }
            >
              {selectedUser?.user_status_flg === 1 ? "Active" : "Inactive"}
            </TagComp>
          </div>
          {/* Send password reset link */}

          {/* Role and Permission details */}
          {selectedUser?.role_name && (
            <div className={style["footer-box"]}>
              <div className="flex gap-3">
                <div className={style["user-icon-container"]}>
                  <UserIcon />
                </div>
                <div className="flex flex-column gap-1">
                  <h6 className={style["details-value"]}>Role</h6>
                  <p className="text-normal text-gray">
                    {selectedUser?.role_name}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </ModalComp>
  );
}

export default UserDetails;
